import { bookOnVrbo } from "@/lib/booking";
import { PROPERTY, VRBO_ID, DOMAIN } from "@/data/property";

const links = [
  { href: "#story", label: "The House" },
  { href: "#gallery", label: "Gallery" },
  { href: "#amenities", label: "Amenities" },
  { href: "#baseball", label: "Rocker B Ranch" },
  { href: "#contact", label: "Contact" },
];

export function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="font-display text-4xl tracking-tight">
              PK <span className="italic">Lake House</span>
            </p>
            <p className="mt-5 max-w-md text-primary-foreground/70 font-light leading-relaxed">
              A luxury waterfront vacation rental on Possum Kingdom Lake in Graford, Texas. Six bedrooms, sleeps 18,
              with a private dock, pool and hot tub — a top-rated lake house rental near Graham, Graford and Rocker B
              Ranch baseball tournaments.
            </p>
            <button
              onClick={() => bookOnVrbo("footer")}
              data-testid="footer-book-button"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-medium text-primary transition-all duration-300 hover:gap-3 hover:bg-white/90"
            >
              Book on VRBO
              <span aria-hidden>&rarr;</span>
            </button>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="text-xs uppercase tracking-[0.18em] text-primary-foreground/50">Explore</p>
            <ul className="mt-5 space-y-3">
              {links.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-primary-foreground/80 hover:text-white transition-colors font-light">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.18em] text-primary-foreground/50">Details</p>
            <ul className="mt-5 space-y-3 text-primary-foreground/80 font-light">
              <li>{PROPERTY.location}</li>
              <li>{PROPERTY.bedrooms} BR · Sleeps {PROPERTY.sleeps}</li>
              <li>VRBO #{VRBO_ID}</li>
              <li>{PROPERTY.rating}/10 · {PROPERTY.reviewCount} reviews</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-white/15 pt-8 text-sm text-primary-foreground/60">
          <p>© {new Date().getFullYear()} PK Lake House · {DOMAIN}</p>
          <div className="flex items-center gap-5">
            <p className="font-light">Hosted by Michael Avidon · Graford, Texas</p>
            <a href="/owner" data-testid="owner-login-link" className="text-primary-foreground/50 hover:text-white transition-colors">Owner</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
